import {
  CLEAR_DATOS_POST_NOMINA,
  CLEAR_EXISTE_NOMINA,
  CLEAR_NOMINA,
  EXISTE_NOMINA,
  GET_CANTIDAD_DIAS_INGRESO_FUTURO,
  GET_INFO_ESTRUCTURA_ARCHIVO,
  GET_NOMINA_ACTIVA_COMBO_BOX,
  GET_TEMPLATE_NOMINA,
  IMPORTAR_NOMINA,
  POST_DATOS_DOMICILIARIOS,
  POST_DATOS_NOMINALES,
  POST_DATOS_PARTICULARES,
  POST_LAST_FORM,
  SAVE_CUIL,
  GET_NOMINA_COMPLETA,
} from "../actions/nomina";

const INITIAL_STATE = {
  cuil: 0,
  nomina: {
    loading: false,
    error: false,
    data: {},
  },
  existeNomina: {
    loading: false,
    error: false,
    data: null,
  },
  postNomina: {
    datosParticulares: {},
    datosDomiciliarios: {},
    datosNominales: {},
  },
  nominaActivaCombo: {
    loading: false,
    error: false,
    data: [],
  },
  templateNomina: {
    loading: false,
    error: false,
    data: null,
  },
  infoEstructuraArchivo: {
    loading: false,
    error: false,
    data: null,
  },
  cantidadDiasIngresoFuturo: {
    loading: false,
    error: false,
    data: 0,
  },
  nominaCompleta: {
    loading: false,
    error: false,
    data: [],
  }
};

const contrato = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_NOMINA_ACTIVA_COMBO_BOX}_PENDING`:
      return {
        ...state,
        nominaActivaCombo: {
          ...state.nominaActivaCombo,
          error: false,
          loading: true,
        },
      };
    case `${GET_NOMINA_ACTIVA_COMBO_BOX}_REJECTED`:
      return {
        ...state,
        nominaActivaCombo: {
          ...state.nominaActivaCombo,
          error: true,
          loading: false,
        },
      };
    case `${GET_NOMINA_ACTIVA_COMBO_BOX}_FULFILLED`:
      return {
        ...state,
        nominaActivaCombo: {
          data: action.payload.data.map((item) => ({
            id: item.idNomina,
            nombre: `${item.nombreCompleto} (${item.cuil}) - Ingreso: ${new Date(item.fechaIngreso).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`,
          })),
          loading: false,
          error: false,
        },
      };
    case `${IMPORTAR_NOMINA}_PENDING`:
      return {
        ...state,
        nomina: { ...state.nomina, error: false, loading: true },
      };
    case `${IMPORTAR_NOMINA}_REJECTED`:
      return {
        ...state,
        nomina: { ...state.nomina, error: true, loading: false },
      };
    case `${IMPORTAR_NOMINA}_FULFILLED`:
      return {
        ...state,
        nomina: {
          ...state.nomina,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${EXISTE_NOMINA}_PENDING`:
      return {
        ...state,
        existeNomina: { ...state.existeNomina, error: false, loading: true },
      };
    case `${EXISTE_NOMINA}_REJECTED`:
      return {
        ...state,
        existeNomina: { ...state.existeNomina, error: true, loading: false },
      };
    case `${EXISTE_NOMINA}_FULFILLED`:
      return {
        ...state,
        existeNomina: {
          ...state.existeNomina,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_LAST_FORM}_PENDING`:
      return {
        ...state,
        sendNomina: { ...state.sendNomina, error: false, loading: true },
      };
    case `${POST_LAST_FORM}_REJECTED`:
      return {
        ...state,
        sendNomina: { ...state.sendNomina, error: true, loading: false },
      };
    case `${POST_LAST_FORM}_FULFILLED`:
      return {
        ...state,
        sendNomina: {
          ...state.sendNomina,
          error: false,
          loading: false,
          data: action.payload,
        },
      };
    case `${GET_TEMPLATE_NOMINA}_PENDING`:
      return {
        ...state,
        templateNomina: {
          ...state.templateNomina,
          loading: true,
          error: false
        }
      };
    case `${GET_TEMPLATE_NOMINA}_REJECTED`:
      return {
        ...state,
        templateNomina: {
          ...state.templateNomina,
          loading: false,
          error: true,
          data: null
        }
      };
    case `${GET_TEMPLATE_NOMINA}_FULFILLED`:
      return {
        ...state,
        templateNomina: {
          ...state.templateNomina,
          error: false,
          loading: false,
          data: action.payload.data
        }
      };
    case `${GET_INFO_ESTRUCTURA_ARCHIVO}_PENDING`:
      return {
        ...state,
        infoEstructuraArchivo: {
          ...state.infoEstructuraArchivo,
          loading: true,
          error: false
        }
      };
    case `${GET_INFO_ESTRUCTURA_ARCHIVO}_REJECTED`:
      return {
        ...state,
        infoEstructuraArchivo: {
          ...state.infoEstructuraArchivo,
          loading: false,
          error: true,
          data: null
        }
      };
    case `${GET_INFO_ESTRUCTURA_ARCHIVO}_FULFILLED`:
      return {
        ...state,
        infoEstructuraArchivo: {
          ...state.infoEstructuraArchivo,
          loading: true,
          error: false,
          data: action.payload.data
        }
      };
    case `${GET_CANTIDAD_DIAS_INGRESO_FUTURO}_PENDING`:
      return {
        ...state,
        cantidadDiasIngresoFuturo: {
          ...state.cantidadDiasIngresoFuturo,
          error: false,
          loading: true,
        },
      };
    case `${GET_CANTIDAD_DIAS_INGRESO_FUTURO}_REJECTED`:
      return {
        ...state,
        cantidadDiasIngresoFuturo: {
          ...state.cantidadDiasIngresoFuturo,
          error: true,
          loading: false,
        },
      };
    case `${GET_CANTIDAD_DIAS_INGRESO_FUTURO}_FULFILLED`:
      return {
        ...state,
        cantidadDiasIngresoFuturo: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_NOMINA_COMPLETA}_PENDING`:
      return {
        ...state,
        nominaCompleta: {
          ...state.nominaCompleta,
          error: false,
          loading: true,
        },
      };
    case `${GET_NOMINA_COMPLETA}_REJECTED`:
      return {
        ...state,
        nominaCompleta: {
          ...state.nominaCompleta,
          error: true,
          loading: false,
        },
      };
    case `${GET_NOMINA_COMPLETA}_FULFILLED`:
      return {
        ...state,
        nominaCompleta: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case POST_DATOS_PARTICULARES:
      return {
        ...state,
        postNomina: {
          ...state.postNomina,
          datosParticulares: { ...action.payload },
        },
      };
    case POST_DATOS_DOMICILIARIOS:
      return {
        ...state,
        postNomina: {
          ...state.postNomina,
          datosDomiciliarios: { ...action.payload },
        },
      };
    case POST_DATOS_NOMINALES:
      return {
        ...state,
        postNomina: {
          ...state.postNomina,
          datosNominales: { ...action.payload },
        },
      };
    case CLEAR_DATOS_POST_NOMINA:
      return {
        ...state,
        postNomina: INITIAL_STATE.postNomina,
      };
    case SAVE_CUIL:
      return {
        ...state,
        cuil: action.payload,
      };
    case CLEAR_EXISTE_NOMINA:
      return {
        ...state,
        existeNomina: {
          ...INITIAL_STATE.existeNomina,
        },
      };
    case CLEAR_NOMINA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default contrato;
